import { createClient } from '@libsql/client';
import { nanoid } from 'nanoid';

const db = createClient({
  url: import.meta.env.VITE_TURSO_DB_URL,
  authToken: import.meta.env.VITE_TURSO_AUTH_TOKEN
});

const DEFAULT_WHAT_WE_DO_CONTENT = {
  lastUpdated: new Date().toISOString(),
  pageTitle: "What We Do",
  sections: [
    {
      name: "Hero Section",
      id: "hero",
      heading: "What We Do"
    },
    {
      name: "Services",
      id: "services",
      items: [
        {
          id: nanoid(),
          title: "Premium Sales Support",
          description: "Exclusive property listings and premium sales support for international clients.",
          icon: `<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>`
        },
        {
          id: nanoid(),
          title: "Investment & Portfolio Management",
          description: "Expert guidance for real estate investment and portfolio analysis.",
          icon: `<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" /></svg>`
        },
        {
          id: nanoid(),
          title: "Property Sourcing & Acquisition",
          description: "Sourcing and acquiring land or residential properties on behalf of clients.",
          icon: `<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.593 3-9s-1.343-9-3-9m0 18a9.001 9.001 0 01-8.986-10.456M11.986 4.456A9.001 9.001 0 0121 13" /></svg>`
        },
        {
          id: nanoid(),
          title: "Legal & Documentation Support",
          description: "Providing legal guidance and handling all necessary documentation for property transactions.",
          icon: `<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m-5 4h4" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2a10 10 0 100 20 10 10 0 000-20z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 12h-6a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1z" /></svg>`
        }
      ]
    }
  ]
};

async function ensureTableExists() {
  try {
    await db.execute(`
      CREATE TABLE IF NOT EXISTS what_we_do_content (
        id TEXT PRIMARY KEY,
        content_data TEXT,
        updated_at TEXT
      );
    `);
    console.log('what_we_do_content table checked/created.');
  } catch (error) {
    console.error('Error creating table:', error);
    throw error;
  }
}

export const whatWeDoService = {
  async getWhatWeDoContent() {
    await ensureTableExists();
    try {
      const result = await db.execute({
        sql: "SELECT content_data, updated_at FROM what_we_do_content WHERE id = 'what-we-do'",
        args: []
      });

      if (result.rows.length > 0) {
        const content = JSON.parse(result.rows[0].content_data);
        content.lastUpdated = result.rows[0].updated_at;
        return content;
      } else {
        console.log('No content found for What We Do, returning default and saving it.');
        await this.createOrUpdateWhatWeDoContent(DEFAULT_WHAT_WE_DO_CONTENT);
        return DEFAULT_WHAT_WE_DO_CONTENT;
      }
    } catch (error) {
      console.error("Error fetching What We Do content:", error);
      throw new Error('Could not fetch What We Do content from database.');
    }
  },

  async createOrUpdateWhatWeDoContent(content) {
    await ensureTableExists();
    const now = new Date().toISOString();
    try {
      const serializedContent = JSON.stringify({ ...content, lastUpdated: now });
      await db.execute({
        sql: `
          INSERT INTO what_we_do_content (id, content_data, updated_at) VALUES (?, ?, ?)
          ON CONFLICT(id) DO UPDATE SET content_data = ?, updated_at = ?;
        `,
        args: [
          'what-we-do',
          serializedContent,
          now,
          serializedContent,
          now
        ],
      });
      console.log('What We Do content created or updated successfully.');
      return this.getWhatWeDoContent();
    } catch (error) {
      console.error('Error creating/updating What We Do content:', error);
      throw error;
    }
  }
};